import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const RootContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(3),
}));

export const FormContainer = styled('div')(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(3),
}));

export const TableContainer = styled('div')(({ theme }) => ({
  width: "100%",
  marginTop: theme.spacing(3),
})); 